module.exports = __webpack_public_path__ + "static/media/kofte3.9c5b0d91.png";